module.exports = __webpack_public_path__ + "static/011_001-7456d641f1514c4435ce7b6a2aaea886.jpg";